import React, { useCallback, useEffect, useRef, useState } from "react";
import { ExpanderWithHeightTransition } from "components/ExpanderWithHeightTransition";
import {
  selectCurrentSection,
  selectSectionTitles,
  setCurrentSection,
} from "lib/redux/settingsSlice";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { capitalizeFirstLetterOfEachWord } from "lib/utils/capitalizeFirstLetterOfEachWord";
import CustomIcon from "components/CustomIcon";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";

const MobileSidebar = () => {
  const dispatch = useAppDispatch();
  const [dropDownOpen, setDropdownOpen] = useState(false);
  const sectionTitles = [
    ...useAppSelector(selectSectionTitles),
    { id: "templates", title: "Templates" },
  ];
  const [dropDownTitles, setDropDownTitles] = useState<
    { id: string; title: string }[]
  >([]);
  const [currentTitle, setCurrentTitle] = useState<{
    id: string;
    title: string;
  }>();
  const currentSection = useAppSelector(selectCurrentSection);

  useEffect(() => {
    setDropDownTitles(
      sectionTitles.filter((title) => title.id !== currentSection)
    );
    setCurrentTitle(sectionTitles.find((title) => title.id == currentSection));
  }, [currentSection]);

  const handleSectionChange = useCallback(
    (section: string) => {
      dispatch(setCurrentSection(section));
      setDropdownOpen(false);
    },
    [dispatch, setCurrentSection]
  );
  return (
    <div
      className={`relative min-w-[164px] ${
        dropDownOpen && "border-b-0"
      } rounded-2xl bg-white px-3 py-2 shadow-md`}
    >
      {currentTitle && (
        <div
          key={currentTitle.id}
          className={`flex items-center gap-2 whitespace-nowrap rounded-xl px-2 py-[2px] text-[10px] ${
            currentSection === currentTitle.id ? "blue-gradient text-white" : ""
          }`}
          onClick={() => handleSectionChange(currentTitle.id)}
        >
          <div className="h-5 w-5">
            <CustomIcon
              iconName={currentTitle.id}
              stroke={`${
                currentSection === currentTitle.id ? "white" : "black"
              }`}
            />
          </div>
          {capitalizeFirstLetterOfEachWord(currentTitle.title)}
        </div>
      )}
      <div
        className="absolute right-0 top-1/2 z-30 h-4 w-4 -translate-y-1/2 translate-x-1/2 rounded-full bg-[#4E4E4E] p-[2px] text-white"
        onClick={() => setDropdownOpen(!dropDownOpen)}
      >
        {dropDownOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </div>
      <div className={`absolute left-0 top-0 z-20 w-full rounded-2xl bg-white`}>
        <ExpanderWithHeightTransition expanded={dropDownOpen} overflowHidden>
          <ul className="flex w-full flex-col gap-1 rounded-b-2xl px-2 py-3 text-[10px] shadow-2xl">
            {currentTitle && (
              <li
                key={currentTitle.id}
                className={`flex items-center gap-2 rounded-xl px-2 py-[2px] ${
                  currentSection === currentTitle.id
                    ? "blue-gradient text-white"
                    : ""
                }`}
                onClick={() => handleSectionChange(currentTitle.id)}
              >
                <div className="h-5 w-5">
                  <CustomIcon
                    iconName={currentTitle.id}
                    stroke={`${
                      currentSection === currentTitle.id ? "white" : "black"
                    }`}
                  />
                </div>
                {capitalizeFirstLetterOfEachWord(currentTitle.title)}
              </li>
            )}
            {dropDownTitles.map((title) => {
              return (
                <li
                  key={title.id}
                  className={`flex items-center gap-2 rounded-xl px-2 py-[2px] ${
                    currentSection === title.id
                      ? "blue-gradient text-white"
                      : ""
                  }`}
                  onClick={() => handleSectionChange(title.id)}
                >
                  <div className="h-5 w-5">
                    <CustomIcon
                      iconName={title.id}
                      stroke={`${
                        currentSection === title.id ? "white" : "black"
                      }`}
                    />
                  </div>
                  {capitalizeFirstLetterOfEachWord(title.title)}
                </li>
              );
            })}
          </ul>
        </ExpanderWithHeightTransition>
      </div>
    </div>
  );
};

export default MobileSidebar;
